<template>
  <div class="bg-gray-50 border-t p-6 rounded-b-md">
    <slot />
  </div>
</template>